// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"vx_a bhb_b bhb_ux"};